// ============================================================================
// mailRenderer.tsx — ПРИЛОЖЕНИЕ «ПОЧТА» (code/appKind 'mail').
//
// Точка входа экрана «Почта: Входящие» в оболочке «Предприятие». Как и другие
// системные приложения, рендерер регистрируется клиентом и открывается по коду
// (AppPage `/designer/app/mail`, док/«Пуск» — когда приложение есть в составе
// воркспейса; серверный догон — metadata.EnsureSystemMailApp).
//
// Данные — СУЩЕСТВУЮЩИЕ RPC: список ящиков — MailService (доступ/изоляция
// на сервере), письма и папки — MetadataService.ExecuteHydraql по таблицам
// серверного почтового механизма. Новых proto/SDK-методов нет.
// ============================================================================

import { registerAppRenderer, type AppManifest, APPSDK_VERSION } from '@/lib/apps/sdk';
import { MailInboxScreen } from '@/components/mail/MailInboxScreen';
import { MAIL_APP_CODE } from '@/lib/mail/mailData';
import { useMailAccessState } from '@/lib/mailAccess';

/** Манифест приложения «Почта» (AppHost): системное, на весь воркспейс. */
export const MAIL_APP_MANIFEST: AppManifest = {
  code: MAIL_APP_CODE,
  name: MAIL_APP_CODE,
  synonym: 'Почта',
  appKind: MAIL_APP_CODE,
  area: 'full',
  apiVersion: APPSDK_VERSION,
  permissions: ['data:read', 'events', 'notify'],
};

function MailApp() {
  const access = useMailAccessState();
  if (access === 'loading') {
    return <div className="p-6 text-sm text-muted-foreground">Проверка доступа к почте…</div>;
  }
  if (access === 'denied') {
    return (
      <div className="p-6 text-sm text-muted-foreground">
        Почта недоступна. Обратитесь к администратору — он может открыть вам доступ.
      </div>
    );
  }
  return <MailInboxScreen />;
}

export function registerMailApp(): void {
  registerAppRenderer({
    appKind: MAIL_APP_CODE,
    code: MAIL_APP_CODE,
    title: 'Почта',
    Component: MailApp,
    manifest: MAIL_APP_MANIFEST,
  });
}
